<template>
    <div>
        <PurchaseMaster addNew="/purchase/debit-note/" type="DN"></PurchaseMaster>
    </div>
</template>
<script>
import { mapState } from "vuex";
import PurchaseMaster from './master.vue'

export default {
    components: { PurchaseMaster },
    computed:{
    ...mapState({
        language_terms: state => state.languages.language_terms,
      }),
    }
}
</script>
